<template>
  <div class="c-page-layout">
    <transition name="fade">
      <!-- don't use :key -->
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'PageLayout',

  components: {},

  data: function () {
    return {}
  },

  computed: {},

  methods: {}
}
</script>

<style lang="css" scoped>
.c-page-layout {
  background-color: var(--v-sheet-base);
  height: 100%;
  /* overflow-y: hidden; */
}
</style>
